/**
 * DatePicker — НАТИВНЫЙ <input type="date">.
 *
 * Раньше был react-day-picker в поповере, но его сетка дней ненадёжно рендерилась во фрейме
 * amoCRM (Safari) — виден только заголовок месяца без чисел. Нативный date-input показывает
 * системный календарь во всех браузерах, отдаёт значение строго в YYYY-MM-DD (без сдвига TZ).
 *
 * Значение на проводе — ymd (YYYY-MM-DD). Пропсы open/onOpenChange/trigger/align оставлены
 * опциональными для обратной совместимости со старыми вызовами и НЕ используются.
 */

import { type ReactNode } from 'react';
import { cx } from './cx';

export interface DatePickerProps {
  value: string | null;
  onSelect: (ymd: string | null) => void;
  /** @deprecated не используется (нативный input) — оставлено для совместимости вызовов. */
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  trigger?: ReactNode;
  align?: 'start' | 'end';
  className?: string;
  ariaLabel?: string;
}

export function DatePicker({ value, onSelect, className, ariaLabel }: DatePickerProps): JSX.Element {
  return (
    <input
      type="date"
      className={cx('pw-input pw-input--date', className)}
      value={value ?? ''}
      onChange={(e) => onSelect(e.target.value ? e.target.value : null)}
      aria-label={ariaLabel ?? 'Дата'}
    />
  );
}
